import gql from "graphql-tag";

export const ROUTINE = gql`
  query routine($id: String) {
    routine(id: $id) {
      id
      title
      banner
      video
      category {
        id
        title
      }
      createdBy {
        id
        profile {
          nickName
        }
      }
      steps {
        id
        order
        title
        details
    
        routineProduct {
          id
          affiliateLink
          product {
            id
            title
            url
          }
        }
      }
      routineProducts {
        # <-- match the entity field name
        id
        product {
          id
          title
          url
        }
        affiliateLink
        createdAt
      }
    }
  }
`;

export const ROUTINES = gql`
  query routines($userId: String, $title: String) {
    routines(userId: $userId, title: $title) {
      id
      title
      banner
      category {
        id
        title
      }
      createdBy {
        id
        profile {
          nickName
        }
      }
    }
  }
`;

export const CREATE_ROUTINE = gql`
  mutation createRoutine($data: CreateRoutineInput) {
    createRoutine(data: $data) {
      id
    }
  }
`;

export const UPDATE_ROUTINE = gql`
  mutation updateRoutine($id: String!, $data: UpdateRoutineInput!) {
    updateRoutine(id: $id, data: $data) {
      id
    }
  }
`;
export const ADD_PRODUCT_TO_ROUTINE = gql`
  mutation AddProductToRoutine($routineId: String!, $productId: String!, $affiliateLink: String) {
    addProductToRoutine(routineId: $routineId, productId: $productId, affiliateLink: $affiliateLink) {
      id
      routine {
        id
      }
      product {
        id
        title
      }
      affiliateLink
    }
  }
`;
export const DELETE_ROUTINE = gql`
  mutation deleteRoutine($id: String!) {
    deleteRoutine(id: $id)
  }
`;

export const DELETE_ROUTINE_PRODUCT = gql`
  mutation deleteRoutineProduct($id: String!) {
    deleteRoutineProduct(id: $id)
  }
`;

export const UPDATE_ROUTINE_PRODUCT = gql`
  mutation updateRoutineProduct($id: String!, $affiliateLink: String) {
    updateRoutineProduct(id: $id, affiliateLink: $affiliateLink) {
      id
      affiliateLink
    }
  }
`;
